import React from 'react';

import {Typography, Skeleton} from '@mui/material';
import TablePaginationActions, {
	type TablePaginationActionsProps,
} from '@mui/material/TablePagination/TablePaginationActions';

export interface VirtualizedListClassicPagerProps
	extends TablePaginationActionsProps {
	loading?: boolean;
}

import {styled} from '@netx/core-components/Theme';

const VirtualizedListPagerRoot = styled('div', {
	name: 'VirtualizedListPager',
	slot: 'Root',
})(({theme}) => ({
	display: 'flex',
	alignItems: 'center',
}));

// const VirtualizedListPagerLabelPages = styled(Typography, {
// 	name: 'VirtualizedListPager',
// 	slot: 'LabelWrapper',
// })(({theme}) => ({
// 	background: theme.palette.custom.background.accent,
// 	borderRadius: 16,
// 	padding: theme.spacing(0.5, 2),
// 	marginLeft: theme.spacing(2),
// }));

const VirtualizedListPagerLabel = styled('div', {
	name: 'VirtualizedListPager',
	slot: 'Label',
})(({theme}) => ({
	paddingRight: theme.spacing(1),
	display: 'flex',
	alignItems: 'center',
}));

export const VirtualizedListClassicPagerPrimitive = (
	props: VirtualizedListClassicPagerProps,
) => {
	const {count, loading, page, rowsPerPage, ...sendProps} = props;

	// const totalPages = Math.ceil(count / rowsPerPage);

	return (
		<VirtualizedListPagerRoot>
			<VirtualizedListPagerLabel>
				{loading ? (
					<Skeleton width={75} />
				) : (
					<>
						<Typography variant="body2">
							{(rowsPerPage * page + 1).toLocaleString() + ' '}-{' '}
							{Math.min(
								rowsPerPage * page + rowsPerPage,
								count,
							).toLocaleString() + ' '}
							of {count.toLocaleString()}{' '}
						</Typography>
						{/* <VirtualizedListPagerLabelPages variant="caption">
							Page {(page + 1).toLocaleString()} of {totalPages.toLocaleString()}
						</VirtualizedListPagerLabelPages> */}
					</>
				)}
			</VirtualizedListPagerLabel>
			<TablePaginationActions
				{...sendProps}
				rowsPerPage={rowsPerPage}
				count={loading ? 0 : count}
				page={loading ? 0 : page}
			/>
		</VirtualizedListPagerRoot>
	);
};

export const VirtualizedListClassicPager = VirtualizedListClassicPagerPrimitive;
export default VirtualizedListClassicPager;
